import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie11';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'typeface-roboto';
import '@fontsource/inter';

import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import LinearProgress from '@material-ui/core/LinearProgress';

import { useMsal, useIsAuthenticated, MsalProvider, UnauthenticatedTemplate, AuthenticatedTemplate } from "@azure/msal-react";
import { InteractionStatus } from '@azure/msal-browser'; 
import { msalInstance } from './auth/msalConfig';

import { ApiRequestInterceptor } from './utils/apiRequestInterceptor';

const theme = createMuiTheme({
    typography: {
      fontFamily: [
        'Inter'
      ].join(','),
    }
  });

function ForceLoginApp() {
    const isAuthenticated = useIsAuthenticated();
    const { instance, inProgress } = useMsal();
  
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance.loginRedirect({});
    }

    return (
        <>
            <AuthenticatedTemplate>
                <ApiRequestInterceptor>
                <ThemeProvider theme={theme}><App /></ThemeProvider>
                </ApiRequestInterceptor>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <LinearProgress></LinearProgress>
            </UnauthenticatedTemplate>        
        </>);
}

function MsalApp() {
    return (
        <MsalProvider instance={msalInstance}>
            <ForceLoginApp></ForceLoginApp>
        </MsalProvider>
    )
}

ReactDOM.render(<MsalApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
